import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2a4636c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "Six"),
  /*#__PURE__*/_createTextVNode("liv ")
], -1))
const _hoisted_3 = { class: "links" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "QUICK LINKS", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "About"),
  /*#__PURE__*/_createElementVNode("a", {
    type: "email",
    href: "javascript:;"
  }, "Info@sixliv.com"),
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "91 Westminster Bridge Road, London, SE1 7HW ")
], -1))

import { store } from "@/utils/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("HOME")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/register" }, {
        default: _withCtx(() => [
          _createTextVNode("REGISTER FOR BUSINESS")
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "login",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).handleOpenLogin && _unref(store).handleOpenLogin(...args)))
      }, "Sign Up")
    ]),
    _hoisted_5
  ]))
}
}

})